import { render, staticRenderFns } from "./AgendaModalNuovaRipartizione.vue?vue&type=template&id=2f71a460"
import script from "./AgendaModalNuovaRipartizione.vue?vue&type=script&lang=js"
export * from "./AgendaModalNuovaRipartizione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports